<template>
  <v-btn
    depressed
    color="primary"
    class="hide-on-print"
    :block="block ? block : false"
    @click="handlePrint"
  >
    <v-icon dark class="mr-1">print</v-icon>
    Print
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: [
    'block'
  ],
  methods: {
    ...mapActions('application', [
      'setPrintMode',
      'clearPrintMode'
    ]),
    handlePrint () {
      this.setPrintMode()

      window.onafterprint = () => {
        this.clearPrintMode()
        window.onafterprint = null
      }

      window.setTimeout(() => {
        window.print()
      }, 500)
    }
  },
  created () {
    if (this.$route.query.printNow) {
      this.handlePrint()
    }
  }
}
</script>
